<template>
    <div>
        <span v-if="!hideTitle" class="span-subtitle">{{
            $t("active-reception-images-videos-label")
        }}</span>
        <div style="width: 100%">
            <div class="card-active-reception d-flex flex-row">
                <div class="container">
                    <div
                        class="mr-3 mt-3 mb-6"
                        :class="isPdfFile ? 'image-pdf' : 'image'"
                        v-for="(image, index) in images"
                        :key="index"
                    >
                        <span class="spanppt" v-if="isPptFile">{{ image.name }}</span>
                        <span
                            v-if="!readonly"
                            class="delete"
                            @click="$emit('on-delete', index)"
                            >&times;</span
                        >
                        <v-tooltip bottom content-class="tooltip-cls tooltipcls">
                            <template v-slot:activator="{ on, attrs }">
                              <embed
                                v-if="isPdfFile"
                                :src="image.url"
                                width="250"
                                height="200" />
                                <img
                                    v-else
                                    :class="'img-cls-short'+'_'+index"
                                    :src="isPptFile ? '/images/ppt-logoicon.png' : image.url"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="handleClickImg(image, index)"
                                    style="cursor: pointer;"
                                />
                            </template>
                            <span><p>{{ image.name }}</p></span>
                        </v-tooltip>
                    </div>
                    <div
                        v-if="multiple || (!multiple && images.length == 0)"
                        class="d-flex flex-column"
                        style="height: 140px; width: 180px; margin-top: 10px"
                    >
                        <div
                            class="drag-area"
                            @dragover.prevent="onDragOver"
                            @dragleave.prevent="onDragLeave"
                            @drop.prevent="onDrop"
                        >
                            <span
                                v-if="!isDragging"
                                class="d-flex flex-column justify-center align-center"
                            >
                                {{
                                    $t(
                                        "active-recption-images-card-input-title2"
                                    )
                                }}
                                <img
                                    src="/images/_SVGs/folder-open.svg"
                                    alt="open-folder"
                                    onload="SVGInject(this)"
                                    width="20"
                                    height="20"
                                />
                                <span
                                    class="select"
                                    role="button"
                                    @click="onSelectFiles"
                                >
                                    <v-btn
                                        class="search-btn primary-button mt-2"
                                        text
                                        >{{
                                            $t(
                                                "active-recption-images-card-input-title4"
                                            )
                                        }}</v-btn
                                    >
                                </span>
                            </span>
                            <div v-else class="select">
                                <p>
                                    {{
                                        $t(
                                            "active-recption-images-card-input-title3"
                                        )
                                    }}
                                </p>
                            </div>
                            <input
                                accept="image/png, image/jpeg, image/jpg, video/mp4, video/*, application/pdf, application/vnd.ms-powerpoint, .ppt, .pptx, application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                name="file"
                                type="file"
                                class="file"
                                ref="fileInput"
                                :multiple="multiple"
                                @change="(evt) => $emit('on-select-file', evt)"
                            />
                        </div>
                        <span style="margin-bottom: -30px; font-size: 12px">{{
                            $t(isPromoEngine ? "promo-engine-images-card-input-title" : "active-recption-images-card-input-title")
                        }}</span>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog
          transition="dialog-bottom-transition"
          max-width="500"
          v-model="openImgModal"
          class="vdialog-box"
        >
          <template v-slot:default="{ }">
            <div class="div-img-modal">
              <div class="xbtn-img-modal">
                <v-icon class="icon-close-img-modal" @click="openImgModal = false">mdi-close-circle</v-icon>
              </div>
              <img
                ref="modalImage"
                class="img-modal-img"
                :src="opemImgModalData.url"
                v-bind="attrs"
                v-on="on"
              />
            </div>
          </template>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        images: { type: Array },
        hideTitle: { type: Boolean, default: false },
        multiple: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        isPdfFile: { type: Boolean, default: false },
        isPptFile: { type: Boolean, default: false },
        isPromoEngine: { type: Boolean, default: false },
    },
    data() {
        return {
            isDragging: false,
            openImgModal: false,
            opemImgModalData: {}
        };
    },
    watch: {
      openImgModal: {
        handler: function (newValue, oldValue) {
          if(newValue == false) {
            $(document).ready(function() {
              const dialogDiv = $('.v-dialog.v-dialog--active');
              dialogDiv.css('max-width', '600px');
              dialogDiv.css('width', '100%');
              dialogDiv.css('max-height', '100%');
              dialogDiv.css('height', '');

              const imgModalImgCls = $('img-modal-img');
              imgModalImgCls.css('max-width', '600px');
              imgModalImgCls.css('max-height', '400px');

              const divIgmModal = $('.div-img-modal');
              divIgmModal.css('max-width', '600px');
              divIgmModal.css('max-height', '400px');
            });
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
        onSelectFiles() {
            this.$refs.fileInput.click();
        },
        onDragOver(event) {
            event.preventDefault();
            this.isDragging = true;
            event.dataTransfer.dropEffect = "copy";
        },
        onDragLeave(event) {
            event.preventDefault();
            this.isDragging = false;
        },
        onDrop(event) {
            event.preventDefault();
            this.isDragging = false;
            this.$emit("on-drop", event);
        },
        handleClickImg(imgData) {
          if(this.isPptFile) {
            return;
          }
          $(document).ready(function() {
              function setDialogValues(dWith, dMaxWidth, dHeight, dMaxHeight, imgMaxWidth, imgMaxHeight, imgModalMaxWidth, imgModalMaxHeight) {
                  const dialogDiv = $('.v-dialog.v-dialog--active');
                  dialogDiv.css('max-width', dMaxWidth);
                  dialogDiv.css('width', dWith);
                  dialogDiv.css('max-height', dMaxHeight);
                  dialogDiv.css('height', dHeight);

                  const imgModalImgCls = $('.img-modal-img');
                  imgModalImgCls.css('max-width', imgMaxWidth);
                  imgModalImgCls.css('max-height', imgMaxHeight);

                  const divIgmModal = $('.div-img-modal');
                  divIgmModal.css('max-width', imgModalMaxWidth);
                  divIgmModal.css('max-height', imgModalMaxHeight);
              }

              const className = '.img-cls-bigpreview';
              const img = $(String(className));
              let naturalHeight = img[0].naturalHeight;
              let naturalWidth = img[0].naturalWidth;

              if(naturalHeight > naturalWidth) {
                  setDialogValues('auto', 'auto', 'auto', '80vh', 'auto', '80vh', 'auto', '80vh');
              } else {
                  setDialogValues('auto', '50vw', 'auto', 'auto', '50vw', 'auto', '50vw', 'auto');
              }

          });
          this.opemImgModalData = imgData;
          this.openImgModal = true;
      },
    },
    mounted() {},
};
</script>

<style lang="scss">
.span-subtitle {
    color: #4b4849;
    font-size: 20px;
    letter-spacing: 0px;
}

.card-active-reception {
    width: 100%;
    padding: 10px;
    padding-top: 0;
    /* box-shadow: 0 0 5px #f2f2f2; */
    border-radius: 5px;
    overflow: hidden;
}

.card-active-reception .top-active-reception {
    text-align: center;
}
.card-active-reception p {
    font-weight: bold;
    color: #000;
}
.card-active-reception button {
    outline: 0;
    border: 0;
    color: #000;
    border-radius: 4px;
    font-weight: 400;
    padding: 8px 13px;
    width: 100%;
    background: #fefefe;
}

.card-active-reception .drag-area {
    height: 100%;
    border-radius: 5px;
    border: 1px dashed #6c757d;
    background: #f4f3f9;
    color: #fefefe;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: center;
    -webkit-user-select: none;
    margin-top: 0px;
    width: 180px;
    span {
        color: rgba(0, 0, 0, 0.6);
    }
}

.card-active-reception .drag-area .visible {
    font-size: 18px;
}

.card-active-reception .select {
    color: #5256ad;
    margin-left: 5px;
    cursor: pointer;
    transition: 0.4s;

    p {
        color: rgba(0, 0, 0, 0.6);
    }
}

.card-active-reception .select:hover {
    /* opacity: 0.6; */
}

.card-active-reception .container {
    width: 100%;
    /* height: 140px; */
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    /* max-height: 200px; */
    position: relative;
    margin-bottom: 8px;
}

.card-active-reception .container .image {
    max-height: 140px;
    width: 180px;
    margin-right: 5px;
    height: 100%;
    position: relative;
    margin-bottom: 0px;

    img {
        object-fit: contain;
    }
}

.card-active-reception .container .image-pdf {
    max-height: 200px;
    width: 250px;
    margin-right: 5px;
    height: 100%;
    position: relative;
    margin-bottom: 0px;

    img {
        object-fit: contain;
    }
}

.card-active-reception .container .image img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}

.card-active-reception .container .image span {
    position: absolute;
    top: -25px;
    right: 0px;
    font-size: 20px;
    color: #000;
    cursor: pointer;
}

.card-active-reception input,
.card-active-reception .drag-area .on-drop,
.card-active-reception .drag-area.dragover .visible {
    display: none;
}

.delete {
    z-index: 999;
    color: #fe0000 !important;
    float: right;
}

.search-btn {
    border: 1px solid var(--v-primary-base) !important;
    font-weight: 600 !important;
    color: var(--v-primary-base) !important;
    border-radius: 43px !important;
    background: transparent !important;
    text-transform: capitalize !important;
    &:hover {
        background: var(--v-primary-base) !important;
        color: #fff !important;
    }
}

.tooltipcls {
  /* max-width: 180px !important; */
  opacity: 1 !important;
  background-color: grey !important;
  height: 26px;
  p {
    font-size: 12px !important;
  }
}

.div-img-modal {
  max-width: 500px;
  overflow: hidden;
  overflow-y: hidden;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.img-modal-img {
  max-width: 500px;
  aspect-ratio: contain;
}

.xbtn-img-modal {
  display: flex;
  justify-content: flex-end;
  background-color: transparent;
}

.vdialog-box {
  box-shadow: none !important;
}

.icon-close-img-modal {
  color: var(--v-primary-base) !important;
  cursor: pointer;
  margin-top: -30px !important;
  margin-right: -30px !important;
  position: absolute !important;
}

.spanppt {
  font-size: 12px !important;
  margin-right: 40px !important;
  margin-top: 5px !important;
}
</style>
